export const filtersAll = [ //other
  {
    label: 'Общие',
    options: [
      {value: 'state', label: 'Состояние'},
      {value: 'type', label: 'Источник'},
      {value: 'deposit', label: 'Депозит'},
      {value: 'cogort', label: 'Когорта'},
    ],
  },
  {
    label: 'Телеграм',
    options: [
      {value: 'bot_id', label: 'Бот'},
      {value: 'channel_id', label: 'Канал'},
      {value: 'tg_account_id', label: 'Телеграм Аккаунт'},
    ],
  },
  {
    label: 'Отдел продаж',
    options: [
      {value: 'team_id', label: 'Команда'},
      {value: 'manager_id', label: 'Менеджер'},
    ],
  },
  {
    label: 'Influence',
    options: [
      {value: 'inf_traffic_id', label: 'Блогер'},
      {value: 'inf_link_id', label: 'INF Поток'},
      {value: 'inf_bayer_id', label: 'INF Байер'},
    ],
  },
  {
    label: 'Facebook',
    options: [
      {value: 'fb_traffic_id', label: 'Кампания'},
      {value: 'fb_link_id', label: 'FB Поток'},
      {value: 'fb_bayer_id', label: 'FB Байер'},
      {value: 'pixel_id', label: 'Пиксель'},
    ],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'advertiser_id', label: 'Рекламодатель'},
      {value: 'brand_id', label: 'Бренд'},
      {value: 'offer_id', label: 'Оффер'},
      {value: 'landing_id', label: 'Лендинг'},
      {value: 'country_id', label: 'ГЕО'},
    ],
  },
];

export const filtersHeadOfSales = [ //id 8, 30
  {
    label: 'Общие',
    options: [
      {value: 'state', label: 'Состояние'},
      {value: 'type', label: 'Источник'},
      {value: 'cogort', label: 'Когорта'},
    ],
  },
  {
    label: 'Телеграм',
    options: [
      {value: 'bot_id', label: 'Бот'},
      {value: 'channel_id', label: 'Канал'},
      {value: 'tg_account_id', label: 'Телеграм Аккаунт'},
    ],
  },
  {
    label: 'Отдел продаж',
    options: [{value: 'manager_id', label: 'Менеджер'}],
  },
  {
    label: 'Influence',
    options: [
      {value: 'inf_traffic_id', label: 'Блогер'},
      {value: 'inf_bayer_id', label: 'INF Байер'},
    ],
  },
  {
    label: 'Facebook',
    options: [
      {value: 'fb_traffic_id', label: 'Кампания'},
      {value: 'fb_bayer_id', label: 'FB Байер'},
    ],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'brand_id', label: 'Бренд'},
      {value: 'country_id', label: 'ГЕО'},
    ],
  },
];

export const filtersTeamlead = [ //id 16, 17
  {
    label: 'Общие',
    options: [
      {value: 'state', label: 'Состояние'},
      {value: 'type', label: 'Источник'},
      {value: 'cogort', label: 'Когорта'},
    ],
  },
  {
    label: 'Отдел продаж',
    options: [{value: 'manager_id', label: 'Менеджер'}],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'brand_id', label: 'Бренд'},
      {value: 'country_id', label: 'ГЕО'},
    ],
  },
];

export const filtersManager = [ //id 9, 15
  {
    label: 'Общие',
    options: [
      {value: 'state', label: 'Состояние'},
      {value: 'type', label: 'Источник'},
      {value: 'cogort', label: 'Когорта'},
    ],
  },
  {
    label: 'Телеграм',
    options: [
      {value: 'bot_id', label: 'Бот'},
      {value: 'channel_id', label: 'Канал'},
      {value: 'tg_account_id', label: 'Телеграм Аккаунт'},
    ],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'brand_id', label: 'Бренд'},
      {value: 'country_id', label: 'ГЕО'},
    ],
  },
];

